import React from 'react';
import { get } from 'lodash/fp';
import PropTypes from 'prop-types';
import { Table } from 'rsuite';
import StatusLabels from '../../../../constants/reservation/StatusLabels';

const StatusCell = ({ dataKey, rowData, ...props }) => (
  <Table.Cell {...props}>
    {get(rowData.status, StatusLabels) || 'N/A'}
  </Table.Cell>
);

StatusCell.propTypes = {
  dataKey: PropTypes.string.isRequired,
  rowData: PropTypes.shape({ status: PropTypes.number })
};

StatusCell.defaultProps = {
  rowData: null
};

export default StatusCell;
